import { Loader2 } from "lucide-react";
import { L } from "@/i18n";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export const ConfirmDialog = ({ open, onOpenChange, title, description, confirmLabel, danger, loading, onConfirm }) => (
  <AlertDialog open={open} onOpenChange={(o) => !loading && onOpenChange(o)}>
    <AlertDialogContent className="bg-[#131f37] border-[#1e293b]" data-testid="confirm-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle className="font-heading text-slate-50" data-testid="confirm-dialog-title">{title}</AlertDialogTitle>
        <AlertDialogDescription className="text-slate-400">{description}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel disabled={loading} className="bg-transparent border-slate-700 text-slate-300 hover:bg-slate-800 hover:text-slate-100" data-testid="confirm-dialog-cancel">
          {L("Cancel", "Cancelar")}
        </AlertDialogCancel>
        <AlertDialogAction
          disabled={loading}
          onClick={(e) => {
            e.preventDefault();
            onConfirm();
          }}
          className={danger ? "bg-rose-600 hover:bg-rose-500 text-white" : "bg-amber-500 hover:bg-amber-400 text-[#0a1425]"}
          data-testid="confirm-dialog-confirm"
        >
          {loading && <Loader2 className="h-4 w-4 animate-spin mr-2" />}
          {confirmLabel}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
